import FullScreenLoader from '@components/FullScreenLoader/FullScreenLoader.component'
import React, { FC, useContext } from 'react'
import NotFound from '@views/404/NotFound.component'
import { GuestContext } from './Guest.context'
import { useSetupGuestContext } from './hooks/useSetupGuestContext'
import { Redirect } from 'react-router-dom'
import { guestTimeDiscountRoute } from './route'
import { getRouteWithParams } from './utils'
import Error from '@components/Error/Error.component'

export const Guest: FC = () => {
    useSetupGuestContext()
    const { error, loading, preflightData } = useContext(GuestContext)

    if (loading) {
        return <FullScreenLoader />
    }

    if (error) {
        // TODO error screens
        return <Error />
    }

    if (preflightData?.purpose === 'customer_whitelist' || preflightData?.purpose === 'time_discount') {
        // redirect to the customer whitelist or time discount page
        return <Redirect to={getRouteWithParams(guestTimeDiscountRoute())} />
    }

    return <NotFound />
}
